import { DraggableModal } from "Component/Modal";
import React, { useEffect, useState } from "react";
import lineLogin from "Assets/other/login-line.svg";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import Spinner from "Component/Spinner";

const UpdateLogin = ({
  stateProps,
  togglePasswordVisibility,
  handleSubmit,
}) => {
  const {
    email,
    setemail,
    password,
    setpassword,
    showPassword,
    setShowPassword,
    isLoading,
    setIsLoading,
    openModal,
    setOpenModal,
    trigger,
    settrigger,
    passwordNew,
    setpasswordNew,
  } = stateProps;
  //   console.log(openModal, "openModal");

  const hanldleClose = () => {
    setOpenModal(!openModal);
    setpasswordNew("");
    // setpassword('')
  };

  return (
    <div>
      <DraggableModal size="md" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Body>
          <div className="w-full text-lg font-bold text-start">
            <p
              className="text-md font-medium"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Anda harus memperbarui password terlebih dahulu!
            </p>
          </div>
          <div className="mt-4 mx-auto w-full">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6"
                >
                  Passowrd
                </label>
                <div className="mt-2 relative">
                  <input
                    id="password"
                    name="password"
                    placeholder="Masukkan password Anda"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setpassword(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 pr-10"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer text-gray-600"
                  >
                    {showPassword ? (
                      <EyeOffIcon className="h-5 w-5" />
                    ) : (
                      <EyeIcon className="h-5 w-5" />
                    )}
                  </button>
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium leading-6"
                  >
                    Password baru
                  </label>
                </div>
                <div className="mt-2 relative">
                  <input
                    id="passwordNew"
                    name="passwordNew"
                    placeholder="Masukkan password baru Anda"
                    type={setpasswordNew ? "text" : "password"}
                    value={passwordNew}
                    onChange={(e) => setpasswordNew(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 pr-10"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer text-gray-600"
                  >
                    {showPassword ? (
                      <EyeOffIcon className="h-5 w-5" />
                    ) : (
                      <EyeIcon className="h-5 w-5" />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <button
                  //   type="submit"
                  disabled={isLoading}
                  onClick={handleSubmit}
                  className="h-11 flex w-full justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                >
                  {isLoading ? <Spinner classAddition={"w-5"} /> : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              className="h-11 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-sm font-semibold leading-6 text-black  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={hanldleClose}
            >
              Tutup
            </button>
            {/* <button
              onClick={handleSubmit}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-blue-500 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button> */}
          </div>
        </DraggableModal.Footer>
      </DraggableModal>
    </div>
  );
};

export default UpdateLogin;
